import React from 'react'
import { graphql } from 'gatsby'
import { ParallaxBanner } from "react-scroll-parallax";
import Img from "gatsby-image/withIEPolyfill";
import SEO from "../components/seo";
import ArticlePreview from '../components/article-preview'

const Blog = ({data}) => {

  const getText = key => {
    const arr = data.allContentfulTitle.edges;
    const node = arr.find(n => n.node.key === key);

    return node ? node.node.text.text : null;
  }

  const posts = data.allContentfulArticle.edges;

  return (
    <>
      <SEO title="Blog" slug="blog/" />

      <ParallaxBanner
        className="bg-ref-dark"
        style={{
          height: "70vh"
        }}
        layers={[
          {
            amount: -0.2,
            children: (
              <div className="parallax-children-20">
                <Img
                  fluid={data.header.childImageSharp.fluid}
                  objectFit="cover"
                  objectPosition="50% 50%"
                  style={{ height: '100%' }}
                />
              </div>
            )
          }
        ]}
      >
        <div className="parallax-overlay overlay-black">
          <div className="wrapper wrapper-page-header">
            <div className="home-overlay-text">
              <h1>{getText('blog')}</h1>
            </div>
          </div>
        </div>
      </ParallaxBanner>

      <div className="wrapper section bg-ref-light">
        <h2 className="section-headline">Articles récents</h2>
        <div>
          {posts.map(({ node }) => <ArticlePreview key={node.slug} article={node} />)}
        </div>
      </div>
    </>
  )
}

export default Blog;

export const pageQuery = graphql`
  query {
    header: file(relativePath: { eq: "echelle-02.jpeg" }) {
      childImageSharp {
        fluid(maxWidth: 1500) {
          ...GatsbyImageSharpFluid_noBase64
        }
      }
    }
    allContentfulTitle {
      edges {
        node {
          key
          text {
            text
          }
        }
      }
    }
    allContentfulArticle(sort: { fields: [publishDate], order: DESC }) {
      edges {
        node {
          title
          slug
          publishDate
          description {
            childMarkdownRemark {
              html
            }
          }
          heroImage {
            fluid(maxWidth: 900, resizingBehavior: SCALE) {
              ...GatsbyContentfulFluid_tracedSVG
            }
          }
        }
      }
    }
  }
`
